<template>
  <div
    class="prevent-select grid-view-item"
    @click="navigateToPod"
    @keydown.enter.prevent="navigateToPod"
    @keydown.space.prevent="navigateToPod"
    role="link"
    tabindex="0"
  >
    <div class="d-flex justify-center" style="width: 200px; height: 112px">
      <PodThumbnail :item="pod" />
    </div>

    <div class="d-flex justify-end" style="margin-top: -112px; max-height: 24px; min-height: 24px">
      <v-chip size="x-small" v-if="fileType">{{ fileType }}</v-chip>
    </div>

    <div class="d-flex justify-space-between" style="margin-top: 65px; height: 24px">
      <div>
        <v-chip size="x-small" v-if="getVideoDuration">
          {{ videoDuration(getVideoDuration) }}
        </v-chip>
      </div>
    </div>

    <div class="item-name mt-2">
      <v-tooltip location="bottom" open-delay="200" :aria-label="pod.name">
        <template v-slot:activator="{ props }">
          <div v-bind="props" class="text-truncate">
            <span class="accesslink-grid-item-name">
              {{ pod.name }}
            </span>
          </div>
        </template>
        <span>{{ pod.name }}</span>
      </v-tooltip>
    </div>

    <div class="d-flex mt-2">
      <div class="d-flex flex-grow-1 align-center item-attributes">
        <div>{{ isoToDatetime(pod.updatedat) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import PodThumbnail from '@/layouts2/components/PodThumbnail.vue';
import { videoDuration, isoToDatetime } from '@/components/formatters.js';

export default {
  name: 'AccesslinkGridPodItem',
  methods: {
    videoDuration,
    isoToDatetime,
    navigateToPod() {
      this.$router.push({
        name: 'accesslink:view:pod',
        params: {
          podid: this.pod.id,
          nodeid: this.currentNodeId,
        },
      });
    },
  },
  components: { PodThumbnail },
  props: {
    pod: {
      type: Object,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    currentNodeId: {
      type: String,
      required: false,
    },
  },
  computed: {
    rawAsset: function() {
      if (this.pod && this.pod.asset && this.pod.asset.raw && this.pod.asset.raw[0]) {
        return this.pod.asset.raw[0];
      }
      return {};
    },
    fileType: function() {
      return this.rawAsset?.filetype;
    },
    getVideoDuration: function() {
      return this.rawAsset?.duration ? parseFloat(this.rawAsset.duration ?? 0) : null;
    }
  }
}
</script>
